import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { Button } from '../components/ui/Button'
import { Input } from '../components/ui/Input'
import './Auth.css'

export function ForgotPassword() {
  const [email, setEmail]       = useState('')
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)
  const [done, setDone]         = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim()) { setError('Please enter your email address.'); return }
    setLoading(true)
    setError('')

    try {
      const { error: sbError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset-password`,
      })

      if (sbError) {
        setError('Something went wrong. Try again.')
        setLoading(false)
        return
      }

      setDone(true)
    } catch (e) {
      console.error('ForgotPassword: resetPasswordForEmail threw:', e)
      setError('Network error. Check your connection and try again.')
      setLoading(false)
    }
  }

  if (done) {
    return (
      <div className="auth-shell">
        <div className="auth-card auth-card--confirm">
          <a href={process.env.REACT_APP_SITE_URL || 'https://techbench.it'} className="auth-logo" style={{ textDecoration: 'none', justifyContent: 'center' }}>
            <div className="auth-logo__mark">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
                <rect x="1" y="4" width="14" height="9" rx="1.5" stroke="#0a0c10" strokeWidth="1.5"/>
                <path d="M5 8h6M5 10.5h3" stroke="#0a0c10" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M6 2h4" stroke="#0a0c10" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="auth-logo__text">TechBench</span>
          </a>
          <h1 className="auth-title">Check your email</h1>
          <p className="auth-subtitle">
            We sent a password reset link to <strong>{email}</strong>.
            Click it to set a new password. Check your spam folder if you don't see it.
          </p>
          <Link to="/login">
            <Button fullWidth variant="secondary">Back to sign in</Button>
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <a href={process.env.REACT_APP_SITE_URL || 'https://techbench.it'} className="auth-logo" style={{ textDecoration: 'none' }}>
          <div className="auth-logo__mark">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
              <rect x="1" y="4" width="14" height="9" rx="1.5" stroke="#0a0c10" strokeWidth="1.5"/>
              <path d="M5 8h6M5 10.5h3" stroke="#0a0c10" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M6 2h4" stroke="#0a0c10" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
          <span className="auth-logo__text">TechBench</span>
        </a>

        <h1 className="auth-title">Forgot your password?</h1>
        <p className="auth-subtitle">Enter your email and we'll send you a reset link.</p>

        {error && <div className="auth-error" role="alert">{error}</div>}

        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          <Input
            id="email" name="email" type="email" label="Email"
            value={email} onChange={e => { setEmail(e.target.value); setError('') }}
            required autoFocus autoComplete="email"
          />
          <Button type="submit" fullWidth loading={loading} size="lg">
            Send reset link
          </Button>
        </form>

        <p className="auth-switch">
          <Link to="/login">&larr; Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
